"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _xlsx = _interopRequireDefault(require("xlsx"));
var _xlsxStyle = _interopRequireDefault(require("xlsx-style"));
/*
 * @Author: zlt
 * @Date: 2021-12-30 14:42:44
 * @LastEditTime: 2021-12-30 15:41:49
 * @LastEditors: zlt
 * @Description: 文件描述
 * @FilePath: \yilong\src\utils\to_xlsx.js
 */
var ToXlsx = /*#__PURE__*/function () {
  // ref指的是绑定数据的table的ref，
  // title指的是导出表格的名称，记得带后缀xlsx，例如：title='重复导.xlsx';
  // VM  vue 实例
  function ToXlsx(ref, title, VM) {
    (0, _classCallCheck2.default)(this, ToXlsx);
    this.ref = ref;
    this.title = title;
    this.VM = VM;
  }

  /**
   * 自定义表格
   * @returns {Promise<void>}
   */
  return (0, _createClass2.default)(ToXlsx, [{
    key: "createCustomizeTable",
    value: (function () {
      var _createCustomizeTable = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
        var sheet, $e, $table, wb, styleBase, colsWidth, key, cell;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // 方式1
              // let sheet = XLSX2.utils.table_to_sheet(document.querySelector(this.id));

              // 方式2

              try {
                $e = this.VM.$refs[this.ref].$el; // 如果表格加了fixed属性，则导出的文件会生产两份一样的数据，所以可在这里判断一下
                $table = $e.querySelector(".el-table__fixed");
                if (!$table) {
                  $table = $e;
                }
                // 为了返回单元格原始字符串，设置{ raw: true }
                wb = _xlsx.default.utils.table_to_book($table, {
                  raw: true
                });
                this.wb = wb;
                sheet = this.wb.Sheets.Sheet1;
              } catch (e) {
                if (typeof console !== "undefined") console.error(e);
              }

              // 设置单个单元格样式 ，A2对应的是excel表格的A2
              // sheet["A2"].s = {
              //   alignment: {
              //     horizontal: "center",
              //     vertical: "center",
              //     wrap_text: true
              //   }
              // };
              // 单元格样式
              styleBase = {
                alignment: {
                  horizontal: "center",
                  // 水平对齐-居中
                  vertical: "center",
                  // 垂直对齐-居中
                  wrap_text: true // 自动换行
                },
                // 边框
                border: {
                  top: {
                    style: "thin"
                  },
                  bottom: {
                    style: "thin"
                  },
                  left: {
                    style: "thin"
                  },
                  right: {
                    style: "thin"
                  }
                }
              }; // sheet居然是个对象，所以遍历就用for in
              // 偷个懒，因为要所有的表格都居中，所以这里就用for in 遍历设置了，如果只是单个设置，那就用上面的单独设置就行
              colsWidth = [];
              _context.t0 = _regenerator.default.keys(sheet);
            case 4:
              if ((_context.t1 = _context.t0()).done) {
                _context.next = 14;
                break;
              }
              key = _context.t1.value;
              if (!new RegExp("^[A-Za-z0-9]+$").exec(key)) {
                _context.next = 12;
                break;
              }
              cell = key.toString();
              if (sheet[cell].v) {
                _context.next = 10;
                break;
              }
              return _context.abrupt("continue", 4);
            case 10:
              // 设置单元格列宽
              colsWidth.push({
                wpx: 90
              });
              sheet[cell].s = styleBase;
            case 12:
              _context.next = 4;
              break;
            case 14:
              // wpx 字段表示以像素为单位，wch 字段表示以字符为单位
              // 注意，必须从第一个开始设置，不能只设置单独一个
              // !cows是列宽
              sheet["!cols"] = colsWidth;
              try {
                this.openDownloadDialog(this.sheet2blob(sheet), this.title);
              } catch (e) {
                //console.log("自定义表格报错", e);
              }
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createCustomizeTable() {
        return _createCustomizeTable.apply(this, arguments);
      }
      return createCustomizeTable;
    }()
    /**
     * 将表转换为最终excel文件的blob对象，并使用URL.createObjectUR下载它
     * @param sheet 表格配置项
     * @param sheetName 表格名称
     * @returns {Blob}
     */
    )
  }, {
    key: "sheet2blob",
    value: function sheet2blob(sheet, sheetName) {
      sheetName = sheetName || "sheet1";
      var workbook = {
        SheetNames: [sheetName],
        Sheets: {}
      };
      workbook.Sheets[sheetName] = sheet; // 生成excel的配置项

      var wopts = {
        bookType: "xlsx",
        // 要生成的文件类型
        bookSST: false,
        // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
        type: "binary"
      };
      var wbout = _xlsxStyle.default.write(workbook, wopts);
      var blob = new Blob([s2ab(wbout)], {
        type: "application/octet-stream"
      }); // 字符串转ArrayBuffer

      function s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
      }
      return blob;
    }

    /**
     *
     * @param url 生成的文件
     * @param saveName 保存文件名称
     */
  }, {
    key: "openDownloadDialog",
    value: function openDownloadDialog(url, saveName) {
      if ((0, _typeof2.default)(url) == "object" && url instanceof Blob) {
        url = URL.createObjectURL(url); // 创建blob地址
      }
      var aLink = document.createElement("a");
      aLink.href = url;
      aLink.download = saveName || ""; // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
      var event;
      if (window.MouseEvent) event = new MouseEvent("click");else {
        event = document.createEvent("MouseEvents");
        event.initMouseEvent("click", true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      }
      aLink.dispatchEvent(event);
    }
  }]);
}();
var _default = exports.default = ToXlsx;